import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

function Section4({data}) {
    const quoteLeft = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/location/Quotation left.png";
    const quoteRight = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/location/Quotation right.png";
    
    // Text lines for better formatting
    const quoteText = [
        "WE BRING TOGETHER EASYGOING BEACH",
        "VIBES, GREAT SHISHA, AND A MENU FULL OF",
        "FEEL-GOOD FAVORITES."
    ];
    
    // Location button link - directly set to Google Maps URL
    const locationLink = "https://maps.app.goo.gl/YCszZFotsmWmNELn9";
    
    return (
        <div id="section4" className="p-section4 section4 mt-scroll py-5 scroll-div" style={{ backgroundColor: '#f0e7da' }}>
            {/* Add Tropical Avenue font styling */}
            <style>
                {`
                @font-face {
                    font-family: 'Tropical Avenue Personal Use';
                    src: url('/path/to/TropicalAvenuePersonalUse.woff2') format('woff2'),
                         url('/path/to/TropicalAvenuePersonalUse.woff') format('woff');
                    font-weight: normal;
                    font-style: normal;
                }
                
                /* Remove orange hover color from button */
                .section4 .btn-primary {
                    transition: all 0.3s ease;
                }
                .section4 .btn-primary:hover,
                .section4 .btn-primary:focus,
                .section4 .btn-primary:active {
                    background-color: #003594 !important;
                    borderColor: #003594 !important;
                    box-shadow: none !important;
                }
                `}
            </style>
            
            <Container>
                <Row className="text-center" data-aos="fade-up" data-aos-duration="2500">
                    {/* Quote section with images */}
                    <Col md={12} className="mb-4">
                        <div className="d-flex align-items-center justify-content-center">
                            <Image 
                                src={quoteLeft}
                                className="img-fluid"
                                style={{
                                    width: 'auto', // Changed from fixed width to auto
                                    height: '40px', // Keep fixed height
                                    maxWidth: '40px', // Add max width
                                    marginRight: '10px',
                                    objectFit: 'contain' // Prevent stretching
                                }}
                            />
                            <div className="text-center">
                                {quoteText.map((line, index) => (
                                    <p 
                                        key={index} 
                                        className="headers-font primary fs-5 mb-0"
                                        style={{ 
                                            lineHeight: '1.3',
                                            fontFamily: "'Tropical Avenue Personal Use', sans-serif", // Exact font name
                                            fontSize: '1.25rem',
                                            fontWeight: 'normal',
                                            letterSpacing: '1px' // May need adjustment based on the font
                                        }}
                                    >
                                        {line}
                                    </p>
                                ))}
                            </div>
                            <Image 
                                src={quoteRight}
                                className="img-fluid"
                                style={{
                                    width: 'auto', // Changed from fixed width to auto
                                    height: '40px', // Keep fixed height
                                    maxWidth: '40px', // Add max width
                                    marginLeft: '10px',
                                    objectFit: 'contain' // Prevent stretching
                                }}
                            />
                        </div>
                    </Col>
                    
                    {/* Location button */}
                    <Col md={12} className="my-4">
                        <a 
                            href={locationLink} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn btn-primary px-5 py-3 fw-bold"
                            style={{
                                fontSize: '1.2rem',
                                borderRadius: '25px', // Changed from 8px to 25px
                                textDecoration: 'none',
                                minWidth: '200px',
                                backgroundColor: '#003594', // Changed from #007bff to #003594
                                borderColor: '#003594' // Changed from #007bff to #003594
                            }}
                        >
                            LOCATION
                        </a>
                    </Col>
                    
                   </Row>
            </Container>
        </div>
    );
}

export default Section4;